export const getValidFileTypes = type => {
  switch (type) {
    case "csv":
    case "xls":
      return [
        "text/csv",
        "text/x-csv",
        "application/csv",
        "application/x-csv",
        "application/excel",
        "application/vnd.msexcel",
        "application/vnd.ms-excel",
        "text/tab-separated-values",
        "text/comma-separated-values",
        "text/x-comma-separated-values"
      ];
    case "zip":
      return [
        "application/zip",
        "application/octet-stream",
        "application/x-zip-compressed",
        "application/x-compressed",
        "multipart/x-zip"
      ];
    case "txt":
      return ["text/plain"];
    default:
      return [];
  }
};
